import React from 'react';
import { BsCursor } from '@react-icons/all-files/bs/BsCursor';
import { BsCursorFill } from '@react-icons/all-files/bs/BsCursorFill';

import { decorateComponent } from '../../../documentComponents';
import { TabButton } from './TabButton';

export default decorateComponent(TabButton, 'block', {
  id: 'tabButton',
  allowedParent: ['tabItem'],
  disabledDelete: true,
  disabledClone: true,
  disabledMove: true,
  renderIcon: ({ state }) => (state === 'on' ? <BsCursorFill /> : <BsCursor />),
  renderTitle: ({ state }) => `탭 버튼 ${state}`,
});
